import React from 'react';
import { BlockHandleMenu } from '../../components/BlockHandleMenu';
import { SnippetBacklinkBadge } from '../../components/SnippetBacklinkBadge';

/** Drag handle, convert menu, snippet backlink, and the single drop line. */
const BlockChrome = ({
  block,
  className,
  combinedRef,
  isDragging,
  showDragAffordances,
  showHandle,
  listeners,
  attributes,
  showHandleForDragZone,
  handleMouseEnter,
  handleMouseLeave,
  handleHandleMouseDown,
  handleHandleMouseUp,
  handleHandleContextMenu,
  handleMenu,
  closeHandleMenu,
  runConvertToCallout,
  container,
  snippetBacklinks,
  resolveDocMeta,
  onOpenDoc,
  indicatorZone,
  children,
}) => (
  <div
    ref={combinedRef}
    data-block-id={block.id}
    className={className}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    style={{ opacity: isDragging ? 0.3 : 1 }}
  >
    {/* Invisible extended zone at the left edge keeps the handle reachable */}
    {showDragAffordances && (
      <div
        className="block-drag-zone-extended"
        {...(showHandle ? listeners : {})}
        {...(showHandle ? attributes : {})}
        style={{ touchAction: 'none' }}
        onMouseEnter={showHandleForDragZone}
        onMouseDown={handleHandleMouseDown}
        onMouseUp={handleHandleMouseUp}
      />
    )}

    {/* Drag handle — rounded dot-grid tab, same look as the flow view's */}
    {showDragAffordances && showHandle && (
      <div
        className="block-drag-handle"
        {...listeners}
        {...attributes}
        style={{ touchAction: 'none' }}
        onMouseEnter={showHandleForDragZone}
        onMouseDown={handleHandleMouseDown}
        onMouseUp={handleHandleMouseUp}
        onContextMenu={handleHandleContextMenu}
        title="Drag to move, click to select"
      >
        <div className="block-drag-dots">
          <span className="block-drag-dot" />
          <span className="block-drag-dot" />
          <span className="block-drag-dot" />
          <span className="block-drag-dot" />
          <span className="block-drag-dot" />
          <span className="block-drag-dot" />
        </div>
      </div>
    )}

    {handleMenu && (
      <BlockHandleMenu
        anchorBlockId={block.id}
        onClose={closeHandleMenu}
      >
        <button
          type="button"
          className="callout-menu__item"
          role="menuitem"
          onClick={(e) => {
            e.stopPropagation();
            runConvertToCallout();
          }}
        >
          Convert to section
        </button>
      </BlockHandleMenu>
    )}

    {/* Origin mark — this block is embedded as a snippet elsewhere */}
    {!container &&
      block.type !== 'snippet' &&
      snippetBacklinks?.[block.id]?.length > 0 && (
        <SnippetBacklinkBadge
          links={snippetBacklinks[block.id]}
          resolveDocMeta={resolveDocMeta}
          onOpenDoc={onOpenDoc}
        />
      )}

    {/* The single drop indicator line (only on the editor-wide target) */}
    {indicatorZone && (
      <div
        key={`indicator-${indicatorZone}`}
        className={`drop-indicator drop-indicator-${indicatorZone}`}
      />
    )}

    {/* Container blocks (row, column, callout) render their own children */}
    {children}
  </div>
);

export default BlockChrome;
